import type { AllRouteEndpoints } from "../routeTypes";
export const integrationsDirectCdiSegmentsConfigTestCacheKeys: AllRouteEndpoints[] = [];
